import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  obtenerPrestamosActivos,
  devolverPrestamo,
} from "../redux/actions/index";

const Devolucion = () => {
  const dispatch = useDispatch();
  const prestamosActivos = useSelector((state) => state.prestamosActivos);

  useEffect(() => {
    dispatch(obtenerPrestamosActivos());
  }, [dispatch]);

  

  const handleDevolverPrestamo = async (id) => {
    const confirm = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción devolverá el préstamo y actualizará el stock.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, devolver",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await dispatch(devolverPrestamo(id));
        Swal.fire(
          "Devuelto",
          `El préstamo con ID ${id} ha sido devuelto exitosamente.`,
          "success"
        );
      } catch (error) {
        Swal.fire("Error", "No se pudo devolver el préstamo.", "error");
      }
    }
  };

  return (
    <div className="p-8 bg-backgroundClaro min-h-screen">
      <h2 className="text-4xl font-bold text-textoOscuro mb-4">Préstamos Activos</h2>
      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-400">
          <thead>
            <tr>
              <th className="border border-gray-400 text-textoOscuro p-2">ID</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Cliente</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Productos</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Obra</th>
              <th className="border border-gray-400 text-textoOscuro p-2">
                Fecha de Préstamo
              </th>
              <th className="border border-gray-400 text-textoOscuro p-2">Estado</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {prestamosActivos.length > 0 ? (
              prestamosActivos.map((prestamo) => (
                <tr key={prestamo.id}>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.id}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.Cliente?.nombre || "Sin cliente"}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.DetallePrestamos?.map((detalle) => (
                      <div key={detalle.id}>
                        {detalle.Producto?.nombre || "Producto no disponible"} -{" "}
                        {detalle.cantidad}
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.Obra?.nombre || "Sin obra"}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {new Date(prestamo.fechaPrestamo).toLocaleString()}
                  </td>
                  <td className="border border-gray-400 ttext-textoOscuro p-2">
                    {prestamo.estado}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    <button
                      onClick={() => handleDevolverPrestamo(prestamo.id)}
                      className="bg-blue-500 text-textoOscuro px-4 py-2 rounded hover:bg-blue-600 w-full sm:w-auto"
                    >
                      Devolver
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="border border-gray-400 text-textoOscuro p-2"
                  colSpan="7"
                >
                  No hay préstamos activos.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Devolucion;
